import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {deleteInternationalProduct, getInternationalBrandProducts} from "../../actions/International";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {IMAGE_URL} from "../../path";

function ViewInternationalProducts() {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const location = useLocation();
    const user = location.state.user;
    const { id } = useParams<{ id: string }>();
    const [products, setProducts] = useState<any[]>([]);
    console.log(products);

    function getProducts() {
        getInternationalBrandProducts(Number(id))
            .then((data) => {
                setProducts(data.data);
            }).catch((error) => {
                console.log(error);
        })
    }

    useEffect(() => {
        getProducts();
    }, []);

    const image_url = IMAGE_URL;
    const navigate = useNavigate();

    function handleDelete(id: number) {
        const confirmDelete = window.confirm("Are you sure you want to delete this product?");

        if (confirmDelete) {
            deleteInternationalProduct(id).then(() => {
                alert("Product deleted successfully");
                getProducts();
            })
                .catch(error => {
                    alert("Failed to delete product");
                    console.log(error);
                })
        }
    }


    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user}/>
        <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
            <div className="content-form-button right-align" style={{marginBottom: '20px'}}>
                <button
                    type="button"
                    className="button button-right"
                    onClick={() => {navigate(`/dashboard/international/products/${id}/add`, { state: { user } })}}
                >
                    Add Product
                </button>
            </div>
            <div className="table-container">
                <table className="news-table">
                    <thead>
                    <tr>
                        <th style={{ width: "20%" }}>Product</th>
                        <th style={{ width: "20%" }}>Image</th>
                        <th style={{ width: "20%" }}>Description</th>
                        <th style={{ width: "20%" }}>Tasting Note</th>
                        <th style={{ width: "20%" }}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {(products !== undefined && products !== null && products.length ) > 0 ? products.map((item) => (
                        <tr key={item.id}>
                            <td>{item.name}</td>
                            <td style={{ textAlign: 'center' }}>
                                <img
                                    alt={item.name}
                                    src={`${image_url}${item.image}`}
                                    style={{ height: '150px' }}
                                />
                            </td>

                            <td>
                                {item.description.length > 200
                                    ? item.description.substring(0, 200) + "…"
                                    : item.description}
                            </td>
                            <td><button
                                type="button"
                                className="button button-right"
                                onClick={() => window.open(`${image_url}${item.tasting_notes}`, `_blank`)}
                            >
                                Tasting Note
                            </button></td>
                            <td><button
                                className="button small"
                                onClick={() => navigate(`/dashboard/international/products/${item.id}/edit`, { state: { user } })}
                                style={{ marginRight: "10px", marginBottom: '10px' }}
                            >
                                Edit Product
                            </button>
                                <button
                                    className="button small danger"
                                    onClick={() => handleDelete(item.id)}
                                    style={{ color: "black" }}
                                >
                                    Delete
                                </button></td>
                        </tr>
                    )) : <tr><td colSpan={5} style={{textAlign: "center"}}>No Products found</td></tr>}
                    </tbody>
                </table>
            </div>

        </div>
    </div>
}

export default ViewInternationalProducts;
